var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.$vuetify.breakpoint.smAndDown ? 'margin-top: 65px;' : 'margin-top: 120px;')},[_c('v-container',{attrs:{"fluid":""}},[_c('PropertiesView',{attrs:{"display":_vm.display,"source":"search"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }